import {
  GroupTypeModel,
  GroupTypeModelAttributes,
  GroupTypeModelCreateAttributes,
  GroupTypeModelUpdateAttributes,
  GroupTypeCollection,
} from 'src/models/GroupTypeModel';
import { Notify } from 'quasar';
import {
  GroupTypeAdapterInteface,
  ListGroupTypesInput as BaseListGroupTypesInput,
} from 'src/adapter/GroupTypeAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListGroupTypesInput = BaseListGroupTypesInput;
export class GroupTypeApiClass {
  adapter: GroupTypeAdapterInteface;
  constructor(adapter: GroupTypeAdapterInteface) {
    this.adapter = adapter;
  }
  async listGroupTypes(
    conditions?: ListGroupTypesInput
  ): Promise<{ total: number; data: GroupTypeCollection }> {
    try {
      const res = await this.adapter.listGroupTypes(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (groupType: GroupTypeModelAttributes) => new GroupTypeModel(groupType)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getGroupType(id: string): Promise<GroupTypeModel> {
    try {
      const groupType = await this.adapter.getGroupType(id);
      return new GroupTypeModel(groupType);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createGroupType(
    attributes: GroupTypeModelCreateAttributes
  ): Promise<GroupTypeModel> {
    try {
      const groupType = await this.adapter.createGroupType(attributes);
      Notify.create({
        type: 'positive',
        message: '作成しました',
      });
      return new GroupTypeModel(groupType);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateGroupType(
    id: string,
    attributes: GroupTypeModelUpdateAttributes
  ): Promise<GroupTypeModel> {
    try {
      const groupType = await this.adapter.updateGroupType(id, attributes);
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new GroupTypeModel(groupType);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteGroupType(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteGroupType(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
